
import Vue from "vue"

export default Vue.extend({
  data: () => ({
    params: {
      "sort[list]": "asc",
      "sort[lastName]": "asc",
    },
  }),
})
